import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  id: "card-theme",
  class: "flex flex-col gap-6 w-full"
}
const _hoisted_2 = { class: "bg-white" }
const _hoisted_3 = {
  key: 1,
  id: "card-theme-content",
  class: "flex flex-col gap-6"
}
const _hoisted_4 = {
  id: "logo-preview",
  class: "flex flex-col gap-3"
}
const _hoisted_5 = { class: "text-lg font-medium" }
const _hoisted_6 = { class: "flex justify-center items-center h-32 bg-gray-200 rounded-md" }
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  id: "partners-preview",
  class: "mb-5"
}
const _hoisted_9 = { class: "font-bold text-lg mb-2" }
const _hoisted_10 = {
  key: 0,
  class: "flex flex-wrap justify-center items-center min-h-[150px] bg-gray-200 rounded-md gap-5"
}
const _hoisted_11 = ["src", "alt"]
const _hoisted_12 = {
  key: 1,
  class: "flex flex-wrap justify-center items-center min-h-[150px] bg-gray-200 rounded-md gap-5"
}
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "flex flex-col gap-3" }
const _hoisted_15 = { class: "text-lg font-medium" }
const _hoisted_16 = { class: "flex flex-col gap-3" }
const _hoisted_17 = { class: "text-lg font-medium" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!
  const _component_Logo = _resolveComponent("Logo")!
  const _component_PreviewColors = _resolveComponent("PreviewColors")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_Loader, {
            key: 0,
            loader: _ctx.loading,
            loaderSize: "h-96"
          }, null, 8, ["loader"]))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("section", _hoisted_4, [
              _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.$t("theme.org.logo")), 1),
              _createElementVNode("div", _hoisted_6, [
                (_ctx.logo.length === 0)
                  ? (_openBlock(), _createBlock(_component_Logo, { key: 0 }))
                  : (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      src: _ctx.getFileUrl(_ctx.logo[0]?.image!),
                      alt: "logo",
                      class: "h-20 object-contain",
                      loading: "lazy"
                    }, null, 8, _hoisted_7))
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t("theme.org.partners")), 1),
              (_ctx.partners.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (img, index) => {
                      return (_openBlock(), _createElementBlock("img", {
                        key: index,
                        src: img,
                        alt: img,
                        class: "w-fit h-8 invert",
                        loading: "lazy"
                      }, null, 8, _hoisted_11))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.partners, (src, index) => {
                      return (_openBlock(), _createElementBlock("img", {
                        id: "partners-imgs",
                        key: index,
                        src: _ctx.getFileUrl(src.image!),
                        class: "w-fit mx-2 h-10",
                        loading: "lazy"
                      }, null, 8, _hoisted_13))
                    }), 128))
                  ]))
            ]),
            _createElementVNode("section", _hoisted_14, [
              _createElementVNode("h3", _hoisted_15, _toDisplayString(_ctx.$t("theme.org.primary")), 1),
              _createVNode(_component_PreviewColors, {
                color: _ctx.colors?.primary
              }, null, 8, ["color"])
            ]),
            _createElementVNode("section", _hoisted_16, [
              _createElementVNode("h3", _hoisted_17, _toDisplayString(_ctx.$t("theme.org.secondary")), 1),
              _createVNode(_component_PreviewColors, {
                color: _ctx.colors?.secondary
              }, null, 8, ["color"])
            ])
          ]))
    ])
  ]))
}